import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { GetReasonTypes } from '@/graphql/contracts/_generated_/getReasonTypes.query';
import GetReasonTypesQuery from '@/graphql/contracts/getReasonTypes.query.gql';

export function getReasonTypes() {
  const result = apolloClientContracts.readQuery<GetReasonTypes>({
    query: GetReasonTypesQuery
  });

  return result?.reasonTypes || [];
}
